<h3>Items</h3>
<table *ngIf="tableData.length > 0" class="items-table">
    <thead>
        <tr>
            <th>Description</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Total Price</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of tableData">
            <td>{{item.description}}</td>
            <td>{{item.quantity}}</td>
            <td>{{item.unit_price | currency:(item.currency || 'USD'):'symbol':'1.2-2'}}</td>
            <td>{{item.total_price | currency:(item.currency || 'USD'):'symbol':'1.2-2'}}</td>
        </tr>
    </tbody>
</table>

<p *ngIf="tableData.length === 0">No items found in the invoice.</p>